import { useEffect, useReducer } from "react";
import { Column, Id } from "../../types";
import { generateId } from "../../utils/function";
import { getEventBlocks } from "services/event";
import { useLocation } from "react-router-dom";
import { DEFAULT_BLOCK_IMAGES_BASE_URL } from "utils/constant";
import { getChipsData } from "services/task";
import { getCardPrompt } from "services/card";

const initialArgs = {
	isBlockCallApi: true,
	selectedCardIndex: -1,
	chipsData: [],
	cardAnimation: false,
	openCardAnimation: false,
	columns: [],
	cards: [],
	activeColumn: null,
	activeCard: null,
	boardData: null,
	selectedCardDetail: null,
	cardWrapperLoading: true
};

const reducer = (state: any, action: any) => {
	return { ...state, ...action };
};

const useCardWrapper = () => {

	const location = useLocation();

	const [state, setState] = useReducer(reducer, initialArgs);

	const defaultCards: any = [];
	const defaultBlocks: any = [];

	useEffect(() => {
		if (state?.boardData && defaultCards.length === 0 && state.columns.length === 0) {
			let selectedCardDetail: any;
			state?.boardData.forEach((column: any) => {
				column.cards.map((card: any) => {
					card.columnId = column._id;
					card.id = card._id
					card.isSelected = false;
					defaultCards.push(card);
					if (card?.id === state?.selectedCardDetail?.id) {
						selectedCardDetail = card;
					}
				})
				defaultBlocks.push({
					id: column._id,
					title: column.title,
					image: column.image,
					isSelected: false
				})
			})
			setState({ columns: defaultBlocks, cards: defaultCards, selectedCardDetail })
		}
	}, [state?.boardData, defaultCards, state.columns])

	const resetStateToDefaults = () => {
		setState({ ...initialArgs })
	}

	useEffect(() => {
		resetStateToDefaults();
	}, [location.pathname]);


	function createCard(columnId: Id) {
		const cardsOfColumn = state?.cards.filter((card: any) => card.columnId === columnId)
		const newCard = {
			id: generateId(),
			columnId,
			title: `Card ${cardsOfColumn.length + 1}`,
			tasks: [{ title: "Task 1" }]
		};
		setState({ cards: [[...state?.cards, newCard]] })
	}

	function deleteCard(id: Id) {
		const newCards = state?.cards.filter((card: any) => card.id !== id);
		setState({ cards: newCards })
	}

	function updateCard(id: Id, content: string) {
		const newCards = state?.cards.map((card: any) => {
			if (card.id !== id) return card;
			return { ...card, content };
		});

		setState({ cards: newCards })
	}

	function createNewColumn() {
		const columnToAdd: Column = {
			id: generateId(),
			title: `Block ${state?.columns.length + 1}`,
			image: `${DEFAULT_BLOCK_IMAGES_BASE_URL}/New+Block.svg`
		};

		setState({ columns: [...state?.columns, columnToAdd] })
	}

	function deleteColumn(id: Id) {
		const filteredColumns = state?.columns.filter((col: any) => col.id !== id);
		const newCards = state?.cards.filter((t: any) => t.columnId !== id);
		setState({ columns: filteredColumns, cards: newCards })
	}

	function updateColumn(id: Id, title: string) {
		const newColumns = state?.columns.map((col: any) => {
			if (col.id !== id) return col;
			return { ...col, title };
		});

		setState({ columns: newColumns })
	}

	function updateState(payload: any) {
		setState({ ...state, ...payload })
	}

	function updateCardSelectedState(id: Id, payload: any) {
		let columnId: any;
		const newCards = state?.cards.map((card: any) => {
			if (card.id === id) {
				columnId = card.columnId
				card.isSelected = true
				return { ...card, ...payload };
			} else {
				card.isSelected = false
				return { ...card }
			};

		});
		let isSelectedTMP = newCards.filter((item: any) => item.columnId === columnId).every((card: any) => card.isSelected)
		const newColumns = state?.columns.map((col: any) => {
			if (col.id === columnId) {
				return { ...col, isSelected: isSelectedTMP }
			} else {
				return col;
			}
		});

		setState({ ...state, cards: newCards, columns: newColumns })
	}

	const updateBoardCallApiFlag = (flag: boolean) => {
		setState({ ...state, isBlockCallApi: flag });
	}

	//fetching board data 
	const getBoardData = async (id: string) => {
		const { data } = await getEventBlocks(id, {
			page: 1,
			perPage: 3
		})
		setState({ ...state, isBlockCallApi: false, boardData: data, columns: [], cards: [], cardWrapperLoading: false });
	}

	const fetchChipData = async (cardId: string) => {
		try {
			const response = await getChipsData(cardId);
			return response?.data;
		} catch (error) {
			console.log("Error while updating the task =", error);
		}
	};

	const fetchCardPrompt = async (promptId: string) => {
		try {
			const response: any = await getCardPrompt(promptId);
			return response?.name && response?._id ? { name: response?.name, _id: response?._id } : {};
		} catch (error) {
			console.log("Error fetchCardPrompt =", error);
		}
	};

	return {
		createCard,
		deleteCard,
		updateCard,
		createNewColumn,
		deleteColumn,
		updateColumn,
		fetchChipData,
		fetchCardPrompt,
		getBoardData,
		updateBoardCallApiFlag,
		setState,
		updateCardSelectedState,
		updateState,
		...state
	}
};
export default useCardWrapper;
